"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFavoritesLinkAndText = void 0;
var _featureToggles = require("@ori/feature-toggles");
var _constants = require("../constants");
var _models = require("../models");
var _useTranslations = require("./useTranslations");
// istanbul ignore file @preserve -- Temporary solution

const useFavoritesLinkAndText = () => {
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const favoriteListsEnabled = isFeatureEnabled(_constants.TopAreaFeature.FavouriteLists);
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  return {
    favoritesLink: favoriteListsEnabled ? _models.FavoriteListsLink : _models.FavoritesLink,
    favoritesText: favoriteListsEnabled ? translations.favouriteLists : translations.myFavoriteProducts
  };
};
exports.useFavoritesLinkAndText = useFavoritesLinkAndText;
